import { Box, SxProps, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    height?: number | string;
    sx?: SxProps;
}>;

export const DashedGrid = ({ height, children, sx }: Props) => {
    const theme = useTheme();

    const color = theme.palette.light.main;

    const lineColor = encodeURIComponent(color);

    const svg = `<svg width='40' height='40' xmlns='http://www.w3.org/2000/svg'><line x1='40' y1='0' x2='40' y2='40' stroke='${lineColor}' stroke-width='2' stroke-dasharray='2,2'/><line x1='0' y1='40' x2='40' y2='40' stroke='${lineColor}' stroke-width='2' stroke-dasharray='2,2'/></svg>`;

    return (
        <Box
            sx={{
                width: '100%',
                height: height ?? '100%',
                backgroundImage: `url("data:image/svg+xml;utf8,${svg}")`,
                backgroundRepeat: 'repeat',
                backgroundPosition: '0 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderBottom: `1px dashed ${color}`,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};
